module.exports = __webpack_public_path__ + "img/crows.00c60d6c.jpg";